/**
 * Created by Greg on 3/30/2016.
 */
import React from 'react';
import {Tabs, Tab, Row, Col, Button, Tooltip, OverlayTrigger, Label} from 'react-bootstrap';
import {LinkTable} from './LinkTable.js';
import {NodeTable} from './NodeTable.js';
import {demandValidate} from './../../validation/demandValid';

export var NetInfo = React.createClass({

    getInitialState() {
        return {name: this.props.net.graph.name, desc: this.props.net.graph.desc};
    },

    componentWillReceiveProps(nextProps) {
        let nameChange = nextProps.net.graph.name !== this.props.net.graph.name;
        let descChange = nextProps.net.graph.desc !== this.props.net.graph.desc;
        if (nameChange || descChange) {
            this.setState(Object.assign({}, this.state, {
                name: nextProps.net.graph.name,
                desc: nextProps.net.graph.desc
            }));
        }
    },

    nameChange(e) {
        this.setState(Object.assign({}, this.state, {name: e.target.value}));
    },

    descChange(e) {
        this.setState(Object.assign({}, this.state, {desc: e.target.value}));
    },

    canEdit() {
        return this.props.mode === 'edit';
    },

    hasChanged() {
        let nameChange = this.state.name !== this.props.net.graph.name;
        let descChange = this.state.desc !== this.props.net.graph.desc;
        return (nameChange || descChange);
    },

    applyHandler() {
        this.props.nameDescChange(this.state.name, this.state.desc);
    },

    render: function () {
        let hOffset = 110; // Approximate height
        let pad = 5;
        let rowStyle = {marginTop: 10};
        let applyChangeButton = null;
        if (this.hasChanged()) {
            applyChangeButton = <Row style={rowStyle}><Col xsOffset={4} xs={3}><Button bsStyle="info"
                            onClick={this.applyHandler}>Apply Changes</Button></Col></Row>
        }
        let demandTab = null;
        let demandDescToolTip = null;
        if (this.props.demands.id) {
            demandDescToolTip = <Tooltip id="DemandDescription"><em>Description: </em>{this.props.demands.desc}</Tooltip>
            demandTab = <Tab eventKey={4} title="Demands">
                <p id="DemandIdLabel"><OverlayTrigger placement="bottom" overlay={demandDescToolTip}>
                <Label bsStyle="info">{this.props.demands.id}:</Label>
                    </OverlayTrigger></p>
                <DemandTable demands={this.props.demands} net={this.props.net} height={this.props.height - hOffset - 30} />
                </Tab>;
        }
        return (
        <Tabs id="NetInfoTab" defaultActiveKey={1}>
            <Tab eventKey={1} title="Links">
                <LinkTable links={this.props.net.links} width={this.props.width - pad} height={this.props.height - hOffset} />
            </Tab>
            <Tab eventKey={2} title="Nodes" >
                <NodeTable nodes={this.props.net.nodes} width={this.props.width - pad} height={this.props.height - hOffset} />
            </Tab>
            <Tab eventKey={3} title="General Info">
                <Row style={rowStyle}>
                    <Col xs={3} xsOffset={1}><label className="control-label">Name</label></Col>
                    <Col xs={7}><input type="text" value={this.state.name}
                                       readOnly={!this.canEdit()}
                                               onChange={this.nameChange}
                                               className="form-control"/></Col>
                </Row>
                <Row style={rowStyle}>
                    <Col xs={3} xsOffset={1}><label className="control-label">Description</label></Col>
                    <Col xs={7}><textarea value={this.state.desc} rows="4"
                                          readOnly={!this.canEdit()}
                                               onChange={this.descChange}
                                               className="form-control"/></Col>
                </Row>
                {applyChangeButton}
                <Row style={rowStyle}><Col xsOffset={1} xs={5}><em>Number of Nodes:</em> {this.props.net.nodes.length},</Col><Col xs={6}>
                <em>Number of Links:</em> {this.props.net.links.length}</Col></Row>
           </Tab>
            {demandTab}
        </Tabs>
    );
  }
});


var DemandTable = React.createClass({
    // Create the data to show in the table.
    createData(demands, net) {
        let data = [];
        let index = 0;
        for (let demand of demands.demandList) {
            let p = {id: index, src: demand.source, trg: demand.target,
                    demand: demand.demand,
                    compat: demandValidate(demand, net)};
            data.push(p);
            index++;
        }
        return data;
    },

    render: function () {
        let data = this.createData(this.props.demands, this.props.net);
        return (
            <BootstrapTable data={data} striped={true} keyField="id"
                            condensed={true}
                            trClassName={function(row){if (!row.compat) return "nonCompatible";}}
                            height={this.props.height.toString()}>
                <TableHeaderColumn dataField="src" key={"src"} dataSort={true}
                                   width="80">Start</TableHeaderColumn>
                <TableHeaderColumn dataField="trg" key={"trg"} dataSort={true}
                                   width="80">End</TableHeaderColumn>
                <TableHeaderColumn dataField="demand" key={"demand"}
                                   dataSort={true}
                                   width="80">Demand</TableHeaderColumn>
            </BootstrapTable>);
    }
})



// WEBPACK FOOTER //
// ./src/info/NetInfo.js